"use client"

import { MenuItem } from "./menu-item"

export interface MenuSectionProps {
  title: string
  items: {
    icon: any
    text: string
    id: string
    href: string
  }[]
  activeItem: string | null
}

export const MenuSection = ({ title, items, activeItem }: MenuSectionProps) => {
  return (
    <div className="flex flex-col gap-1">
      <div className="overflow-hidden text-ellipsis px-2 text-xs font-normal leading-[18px] text-[#5D5FEF]">
        {title}
      </div>
      {items.map((item) => (
        <MenuItem
          key={item.id}
          icon={item.icon}
          text={item.text}
          href={item.href}
          variant={activeItem?.startsWith(item.href) ? "active" : "default"}
        />
      ))}
    </div>
  )
}
